export default __webpack_public_path__ + "static/media/about_us_before.8e5187ca.png";